import { render, staticRenderFns } from "./ConfigurationAditionalCard.vue?vue&type=template&id=f1b5d41e&"
import script from "./ConfigurationAditionalCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationAditionalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports